// @flow
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { withRouter } from '../../with-router'
import { Buttons, FormControls } from '@lanetix/unum'
import routerFunction from 'client/route.js'

import AuthService from 'client/utils/auth-service'

// $FlowFixMe 
export class DefaultForm extends Component {
  props: {
    auth: AuthService,
    router: Object,
    connection: {
      name: string
    }
  }

  state: {
    email: string,
    password: string,
    submitted: boolean
  }

  static displayName: string = 'Default Form'
  // $FlowFixMe
  state: any = {
    email: '',
    password: '',
    submitted: false
  }
  // $FlowFixMe
  onSubmit: ((event: any) => Promise<void>) = async (event: SyntheticEvent) => {
    event.preventDefault()
    const { auth, connection } = this.props
    const router = routerFunction()
    const { email, password } = this.state
    // $FlowFixMe
    this.setState({ submitted: true })

    try {
      auth && await auth.loginWithCredentials({
        connection: connection.name,
        email,
        password,
        responseType: 'code'
      })
    } catch (e) {
      router.navigate('/incorrect-password')
    }
  }
  // $FlowFixMe
  onInput: ((any) => void) = ({ target: { value, name } }: SyntheticInputEvent) => {
    this.setState({ [name]: value })
  }

  render (): any {
    const { submitted } = this.state
    const submit = submitted ? 'Loading' : 'Sign In'
    return (
      <form className='login__form' disabled={submitted} onSubmit={this.onSubmit}>
        <FormControls.Text placeholder='Email' type='email' disabled={submitted} name='email' onInput={this.onInput} />
        <FormControls.Text placeholder='Password' type='password' disabled={submitted} name='password' onInput={this.onInput} />
        <Buttons.PillButton className='login__button' type='submit' disabled={submitted} success block>{submit}</Buttons.PillButton>
        <Link to='forgot-password' className='login__forgot-password'>Forgot password?</Link>
      </form>
    )
  }
}

export default (withRouter(DefaultForm): any)
